var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIl1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1060,
    height: 1060,
    viewBox: "0 0 1060 1060",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    #orbit1 {\n        animation: rotate 60s linear infinite;\n        transform-origin: 50% 50%;\n        transform-box: fill-box;\n    }\n    #orbit2 {\n        animation: rotate 40s linear infinite;\n        transform-origin: 50% 50%;\n        transform-box: fill-box;\n    }\n    #orbit3 {\n        animation: rotate 80s linear infinite;\n        transform-origin: 50% 50%;\n        transform-box: fill-box;\n    }\n    @keyframes rotate{\n                from{\n                   transform: rotate(0deg);}to{\n                   transform: rotate(360deg);\n                }\n             }\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 151"
  }, /*#__PURE__*/React.createElement("g", {
    id: "orbit2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M149.219 603.78C144.624 579.641 142.321 555.122 142.339 530.55C142.339 346.497 270.576 192.413 442.541 152.841M529.741 142.984C743.7 142.984 917.142 316.5 917.142 530.55C917.142 583.65 906.468 634.256 887.149 680.336M330.432 862.951C390.608 899.151 459.523 918.223 529.741 918.109C663.42 918.109 781.287 850.374 850.915 747.336",
    stroke: "white",
    strokeWidth: 6.67,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M247.647 796.183C212.879 759.278 185.685 715.907 167.607 668.528",
    stroke: "white",
    strokeWidth: 6.67,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M285.622 859.714C299.106 859.714 310.036 848.779 310.036 835.289C310.036 821.8 299.106 810.865 285.622 810.865C272.138 810.865 261.208 821.8 261.208 835.289C261.208 848.779 272.138 859.714 285.622 859.714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M487.955 169.686C501.439 169.686 512.37 158.75 512.37 145.261C512.37 131.772 501.439 120.836 487.955 120.836C474.472 120.836 463.541 131.772 463.541 145.261C463.541 158.75 474.472 169.686 487.955 169.686Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M157.199 653.713C165.99 653.713 173.117 646.583 173.117 637.788C173.117 628.994 165.99 621.864 157.199 621.864C148.408 621.864 141.282 628.994 141.282 637.788C141.282 646.583 148.408 653.713 157.199 653.713Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M869.459 731.685C878.249 731.685 885.376 724.555 885.376 715.76C885.376 706.966 878.249 699.836 869.459 699.836C860.668 699.836 853.541 706.966 853.541 715.76C853.541 724.555 860.668 731.685 869.459 731.685Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 116",
    x: 0.5,
    y: 0.5,
    width: 1059,
    height: 1059,
    rx: 529.5,
    stroke: "rgba(98,24,38,0)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "orbit3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M346.961 286.735C399.653 247.08 463.829 225.687 529.766 225.798C571.135 225.798 610.578 234.048 646.541 248.993M529.766 835.283C365.579 835.283 231.736 705.334 225.385 542.638M711.346 285.836C786.007 341.377 834.376 430.308 834.376 530.544C834.376 675.726 732.903 797.187 597.041 827.826",
    stroke: "#1AF5BC",
    strokeWidth: 6.67,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M234.494 455.268C244.97 414.079 263.974 375.549 290.278 342.174",
    stroke: "#1AF5BC",
    strokeWidth: 6.67,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M317.464 331.985C328.013 331.985 336.566 323.429 336.566 312.874C336.566 302.32 328.013 293.764 317.464 293.764C306.914 293.764 298.361 302.32 298.361 312.874C298.361 323.429 306.914 331.985 317.464 331.985Z",
    fill: "#1AF5BC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M680.643 286.057C691.193 286.057 699.745 277.501 699.745 266.947C699.745 256.392 691.193 247.836 680.643 247.836C670.093 247.836 661.541 256.392 661.541 266.947C661.541 277.501 670.093 286.057 680.643 286.057Z",
    fill: "#1AF5BC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M564.643 854.057C575.193 854.057 583.745 845.501 583.745 834.947C583.745 824.392 575.193 815.836 564.643 815.836C554.093 815.836 545.541 824.392 545.541 834.947C545.541 845.501 554.093 854.057 564.643 854.057Z",
    fill: "#1AF5BC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M225.124 524.178C239.192 524.178 250.596 512.769 250.596 498.695C250.596 484.621 239.192 473.213 225.124 473.213C211.056 473.213 199.652 484.621 199.652 498.695C199.652 512.769 211.056 524.178 225.124 524.178Z",
    fill: "#1AF5BC"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 115",
    x: 0.5,
    y: 0.5,
    width: 1059,
    height: 1059,
    rx: 529.5,
    stroke: "rgba(98,24,38,0)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "orbit1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M775.955 145.686C789.439 145.686 800.37 134.75 800.37 121.261C800.37 107.772 789.439 96.8362 775.955 96.8362C762.472 96.8362 751.541 107.772 751.541 121.261C751.541 134.75 762.472 145.686 775.955 145.686Z",
    fill: "#5C1FDE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M481.459 1021.68C490.249 1021.68 497.376 1014.56 497.376 1005.76C497.376 996.966 490.249 989.836 481.459 989.836C472.668 989.836 465.541 996.966 465.541 1005.76C465.541 1014.56 472.668 1021.68 481.459 1021.68Z",
    fill: "#5C1FDE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M1007.46 517.685C1016.25 517.685 1023.38 510.555 1023.38 501.76C1023.38 492.966 1016.25 485.836 1007.46 485.836C998.668 485.836 991.541 492.966 991.541 501.76C991.541 510.555 998.668 517.685 1007.46 517.685Z",
    fill: "#5C1FDE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M54.3507 590.455C67.2469 590.455 77.7014 579.996 77.7014 567.095C77.7014 554.193 67.2469 543.734 54.3507 543.734C41.4545 543.734 31 554.193 31 567.095C31 579.996 41.4545 590.455 54.3507 590.455Z",
    fill: "#5C1FDE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M197.474 187.641C215.005 170.596 233.809 154.913 253.723 140.728C401.328 35.5009 588.318 26.2173 740.541 100.427M59.854 609.54C71.8654 680.789 99.934 748.367 141.932 807.15C217.659 913.48 328.926 979.456 448.041 1000.44M514.041 1007.41C615.548 1011.08 719.01 982.512 808.102 918.989C938.886 825.739 1008.59 678.646 1008.55 529.336M809.541 141.621C851.092 171.474 888.519 208.565 919.862 252.567C968.599 320.991 996.746 397.874 1005.54 475.836",
    stroke: "#5C1FDE",
    strokeWidth: 6.67,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M170.104 238.529C181.829 238.529 191.334 229.02 191.334 217.291C191.334 205.561 181.829 196.052 170.104 196.052C158.379 196.052 148.875 205.561 148.875 217.291C148.875 229.02 158.379 238.529 170.104 238.529Z",
    fill: "#5C1FDE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M53.3125 523.553C54.6453 425.092 86.284 329.434 143.919 249.611",
    stroke: "#5C1FDE",
    strokeWidth: 6.67,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 117",
    x: 0.5,
    y: 0.5,
    width: 1059,
    height: 1059,
    rx: 529.5,
    stroke: "rgba(98,24,38,0)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "sun",
    d: "M530.282 621.641C580.695 621.641 621.563 580.756 621.563 530.321C621.563 479.886 580.695 439 530.282 439C479.868 439 439 479.886 439 530.321C439 580.756 479.868 621.641 530.282 621.641Z",
    fill: "#1CF8BD"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIl1);
export default __webpack_public_path__ + "static/media/il1.e2b0359571798d16af5df72ddb7eebe2.svg";
export { ForwardRef as ReactComponent };